(function() {
    /** @ngInject */
    function authCtrl($scope, $state,$http, $timeout, $stateParams){
        $scope.error = '';
        $scope.tokenGenerated = false;
        $scope.isCompleteNext = function(){
            return _.has($stateParams, 'backTo') && $stateParams.complete === 'Y';
        };
        $scope.auth = {
            email: ($scope.isCompleteNext() ? $scope.booking.email : (auth.email ? auth.email : '')),
            name : auth.name ? auth.name : $scope.booking.firstname + ' ' + $scope.booking.lastname,
            code : [],
            save : true
        };
        var backTo = 'meals';
        $scope.sendCode = function(){
            $http.post('/booking-widget/api/sendAuthCode', {email : $scope.auth.email, code : $scope.auth.code.join(''), 'verify' : $scope.isCompleteNext()})
                .then(function(response) {
                    if (response.data.success) {
                        $scope.mode = 'verify';
                        $scope.tokenGenerated = true;
                        $timeout(function(){
                            $scope.tokenGenerated = false;
                        },3000);
                    } else {
                        $scope.error = response.data.errors;
                        $timeout(function(){
                            $scope.error = '';
                        },3000);
                    }
                })
                .catch(function(error) {
                    $scope.error = 'Error sending code. Please try again.';
                });
        };
        $scope.verifyCode = function(){
            $http.post('/booking-widget/api/verifyAuthCode', {save : $scope.auth.save, email : $scope.auth.email, code : $scope.auth.code.join(''), 'verify' : $scope.isCompleteNext()})
                .then(function(response) {
                    if (response.data.success) {
                        if(!$scope.isCompleteNext() && response.data.guest) {
                            auth = {
                                email: response.data.guest.email,
                                firstname: response.data.guest.firstname,
                                lastname: response.data.guest.lastname,
                                mobile: response.data.guest.mobile,
                            };
                        }
                        if(backTo === 'meals'){
                            $scope.goTo('meals');
                        }else{
                            if($scope.isCompleteNext()){
                                completeBooking();
                            }else{
                            $scope.goTo('guest-details');
                            }
                        }
                    } else {
                        $scope.error = response.data.errors;
                        $timeout(function(){
                            $scope.error = '';
                        },3000);
                    }
                })
                .catch(function(error) {
                    $scope.error = 'Error verifying code. Please try again.';
                });
        };
        $scope.moveFocus = function(event, nextTabIndex) {
            const key = event.key;
            const input = event.target;
            if (input.value.length === 1 && key !== 'Backspace' && key !== 'ArrowLeft') {
                const next = document.querySelector(`[tabindex="${nextTabIndex + 1}"]`);
                if (next) next.focus();
            }
            if (key === 'Backspace' && input.value === '') {
                const prev = document.querySelector(`[tabindex="${nextTabIndex - 1}"]`);
                if (prev) prev.focus();
            }
        };
        $scope.handlePaste = function(event) {
            event.preventDefault();
            const paste = (event.originalEvent || event).clipboardData.getData('text');
            // Only allow numeric or alphanumeric characters, adjust as needed
            const chars = paste.replace(/\s/g, '').split('').slice(0, 4);
            chars.forEach((char, i) => {
                $scope.auth.code[i] = char;
                // Optional: update the input value directly if needed
                const input = document.querySelector(`[tabindex="${i + 1}"]`);
                if (input) input.value = char;
            });
            // Move focus to the next empty field
            const nextIndex = chars.length + 1;
            const nextInput = document.querySelector(`[tabindex="${nextIndex}"]`);
            if (nextInput) nextInput.focus();
        };
        function requireLogin(){
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            return !($scope.auth.email && emailRegex.test($scope.auth.email));
        }


        function calculateAuthStep(){
            //check if all widget params are set and guest came from guest-form page
            if($stateParams.action === 'sendAuthCode'){
                backTo = _.has($stateParams, 'backTo') && typeof($stateParams.backTo) !== 'undefined' ? $stateParams.backTo : 'guest-details';
                $scope.sendCode();
                return 'verify';
            }else{
                backTo = 'meals';
                return 'login';
            }
        }
        $scope.getBackTo = function(){ return backTo; };

        $scope.routeBack = function(){
            if(_.has($stateParams, 'backTo') && typeof($stateParams.backTo) !== 'undefined'){
                backTo = $stateParams.backTo;
            }
            if(_.has($stateParams, 'backTo') && $stateParams.complete === 'Y'){
                completeBooking();
                return;
            }
            $scope.goTo(backTo);
        };
        $scope.mode = calculateAuthStep();

        /** Complete the booking */
        $scope.request = false;
        $scope.is_bokabord_web = false;
        function completeBooking() {
            if (!$scope.booking.hasErrors(true)) {
                $scope.request = true;
                $scope.booking.is_bokabord_web = $scope.is_bokabord_web ? 'Y' : 'N';
                if($scope.booking.giftcard){
                    $state.go('payinwidget', {}, {location: false});
                    return;
                }
                $scope.booking.save().success(function (response) {
                    if (response.success !== true || !response.hasOwnProperty('booking')) {
                        alert(response.errors);
                        $scope.request = false;
                        return false;
                    }
                    var bookingObj = null;
                    if (response.booking && response.booking.id > 0) {
                        var d1 = moment(response.booking.date);
                        var d2 = moment();
                        bookingObj = {
                            'regDate': moment().format('YYYY-MM-DD HH:mm'),
                            'bookingDate': response.booking.date,
                            'bookingTime': response.booking.time_formatted,
                            'quantity': response.booking.amount,
                            'totalAmount': $scope.booking.getProductsTotal(),
                            'daysAhead': d1.diff(d2, 'days'),
                            'products': _.size($scope.booking.booking_products),
                            'meal': $scope.booking.meal.name,
                            'amount': $scope.booking.amount,
                            'date': response.booking.date,
                            'time': $scope.booking.time,
                            'averageValue': $scope.booking.meal.avg_gtm_price,
                            'totalValue': ($scope.booking.meal.avg_gtm_price * $scope.booking.amount)
                        };
                    }

                    updateWidgetStep('Reservation-Completed', bookingObj);
                    if (response.booking && response.booking.id > 0) {
                        $scope.booking.initFromDbObj(response.booking);
                        $scope.date = $scope.booking.getDate('YYYY-MM-DD');
                        if (typeof (dataLayer) !== 'undefined' && !testDt) {
                            dataLayer.push({
                                //'event' : 'purchase',
                                'ecommerce': {
                                    'purchase': {
                                        'actionField': {
                                            'id': response.booking.id,
                                            'revenue': restaurant_gtm_price,
                                        },
                                        'products': [
                                            {
                                                'name': $scope.booking.meal.name,       // Name or ID is required.
                                                'brand': restaurant_name,
                                                'category': 'Bordsbokning',
                                                'quantity': $scope.booking.amount,
                                                'firstname': $scope.booking.firstname,
                                                'lastname': $scope.booking.lastname,
                                                'email': $scope.booking.email,
                                                'date': $scope.date,
                                                'dimension15': $scope.booking.amount,
                                                'dimension16': $scope.booking.time,
                                                'dimension17': $scope.booking.getDate('MMDDYY'),
                                                'time': $scope.booking.time,
                                                'waitlist': $scope.booking.waitlist ? 'Y' : 'N',
                                                'meal': $scope.booking.meal.name,
                                                'price': restaurant_gtm_price
                                            }
                                        ]
                                    }
                                }
                            });
                            if (typeof (ga) !== 'undefined') {
                                ga('ec:addProduct', {
                                    'id': response.booking.id,// Product ID (string).
                                    'name': 'Bordsbokning #' + response.booking.id, // Product name (string).
                                    'category': 'Bordsbokning', // Product category (string).
                                    'brand': restaurant_name,
                                    'variant': $scope.booking.meal.name,
                                    'price': restaurant_gtm_price,
                                    'quantity': 1,
                                    'dimension15': $scope.booking.amount,
                                    'dimension16': $scope.booking.time,
                                    'dimension17': $scope.booking.getDate('MMDDYY')
                                });
                            }
                        }
                        if (typeof (window.parent) !== 'undefined') {
                            window.parent.postMessage("reservationSuccess", "*");
                        }
                        if (typeof (dataLayerBokabord) !== 'undefined') {
                            dataLayerBokabord.push({
                                'event': 'Final-Confirmation',
                                'restaurant': restaurant_name
                            });
                        }

                        if (response.booking.status === 0) {
                            $state.go('payinwidget', {}, { location: false });
                        } else {
                            window.setTimeout(function () {
                                window.location = '/reservation/booking/?code=' + response.booking.short_code + '&new=1';
                            }, 1000);
                        }
                    }
                });
            }
        }
    }
    angular.module("Waiteraid").controller("authCtrl", authCtrl);
})();
